import axios from 'axios'


// console.log('process:',process.env)
// 创建axios对象
const request = axios.create({
  // 根目录下的 .env.development 与 .env.production 中配置 VUE_APP_BASE_API
  baseURL: process.env.VUE_APP_BASE_API,  // /dev-api/
  timeout:5000  //请求超时时间
})
// 请求拦截器
request.interceptors.request.use(config=>{
  // 请求拦截
  return config
  },error=>{
  // 异常
  return Promise.reject(error)
})
// 响应拦截器
request.interceptors.response.use(response=>{
  // 响应的数据  response.data
  return response
  },error=>{
  // 异常
  return Promise.reject(error)
})

export default request  //导出自定义创建的axios对象



// WEBPACK FOOTER //
// ./src/utils/request.js